"use client";

import createIcon from './util/createIcon';
export default createIcon('M9 14H2V16H9V19L13 15L9 11V14M15 13V10H22V8H15V5L11 9L15 13Z', 'CompareHorizontal');